import React from "react";

const data = {
  product_profit_data: [
    {
      product_name: "HP Spectre x360",
      profit: 0.0,
      loss: 124.11,
      total_product_count: 1,
    },
    {
      product_name: "Apple iPhone 14",
      profit: 82936.82,
      loss: 11203571.02,
      total_product_count: 2,
    },
    {
      product_name: "Samsung Galaxy S24",
      profit: 0.0,
      loss: 196.0,
      total_product_count: 1,
    },
  ],
  suppliers_data: [
    {
      supplier_name: "William Brown",
      total_amount: 46253.0,
    },
    {
      supplier_name: "Jhon",
      total_amount: 309.0,
    },
  ],
};

const totalProfit = data.product_profit_data.reduce((acc, item) => acc + item.profit, 0);
const totalLoss = data.product_profit_data.reduce((acc, item) => acc + item.loss, 0);
const netProfit = totalProfit - totalLoss;
const totalSupplierAmount = data.suppliers_data.reduce((acc, item) => acc + item.total_amount, 0);

const FinanceDashboard = () => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-center mb-6">Finance Dashboard</h1>

      {/* Profit & Loss Card */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="p-6 bg-white shadow-md rounded-lg text-center border">
          <h2 className="text-xl font-semibold">Total Profit</h2>
          <p className="text-green-500 text-2xl font-bold">₹{totalProfit.toFixed(3)}</p>
        </div>
        <div className="p-6 bg-white shadow-md rounded-lg text-center border">
          <h2 className="text-xl font-semibold">Total Loss</h2>
          <p className="text-red-500 text-2xl font-bold">₹{totalLoss.toFixed(3)}</p>
        </div>
        <div className="p-6 bg-white shadow-md rounded-lg text-center border">
          <h2 className="text-xl font-semibold">Net Profit/Loss</h2>
          <p className={`text-2xl font-bold ${netProfit >= 0 ? "text-green-500" : "text-red-500"}`}>
            ₹{netProfit.toFixed(3)}
          </p>
        </div>
      </div>

      {/* General Ledger Table */}
      <div className="mt-8 bg-white p-6 shadow-md rounded-lg">
        <h2 className="text-xl font-semibold mb-4">General Ledger</h2>
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border p-2">Account</th>
              <th className="border p-2">Debit (₹)</th>
              <th className="border p-2">Credit (₹)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border p-2">Sales Revenue</td>
              <td className="border p-2"></td>
              <td className="border p-2">{totalProfit.toFixed(3)}</td>
            </tr>
            <tr>
              <td className="border p-2">Cost of Goods Sold</td>
              <td className="border p-2">{totalLoss.toFixed(3)}</td>
              <td className="border p-2"></td>
            </tr>
            <tr>
              <td className="border p-2">Supplier Payables</td>
              <td className="border p-2">{totalSupplierAmount.toFixed(3)}</td>
              <td className="border p-2"></td>
            </tr>
            <tr className="font-bold bg-gray-100">
              <td className="border p-2">Net Profit/Loss</td>
              <td className="border p-2">{netProfit < 0 ? Math.abs(netProfit).toFixed(3) : ""}</td>
              <td className="border p-2">{netProfit >= 0 ? netProfit.toFixed(3) : ""}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FinanceDashboard;
